import { STATUS_CONFIG } from './constants';

interface SuccessModalData {
  type?: string;
  message?: string;
  booking?: {
    booking_code?: string;
    service_date?: string;
    start_time?: string;
    time?: string;
    end_time?: string;
    customer_name?: string;
    customer_address?: string;
    status?: string;
  };
}

interface BookingsSuccessModalProps {
  successModal: SuccessModalData | null;
  onClose: () => void;
  formatBookingDate: (dateStr: string) => string;
}

function BookingsSuccessModal({ successModal, onClose, formatBookingDate }: BookingsSuccessModalProps) {
  if (!successModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal booking-success-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: successModal.booking ? '420px' : '340px' }}
      >
        {successModal.type === 'updated' && successModal.booking ? (
          <>
            <div className="wizard-success-icon">{'\u2713'}</div>
            <h2 className="wizard-success-title">Booking Updated</h2>
            <div className="booking-code-display">
              {successModal.booking.booking_code}
            </div>
            <p className="wizard-success-subtitle">
              The booking has been updated successfully.
            </p>
            <div className="wizard-success-details">
              <div className="wizard-success-row">
                <span className="wizard-success-label">Date & Time</span>
                <span className="wizard-success-value">
                  {formatBookingDate(successModal.booking.service_date || '')} at {successModal.booking.start_time || successModal.booking.time}
                  {successModal.booking.end_time && ` - ${successModal.booking.end_time}`}
                </span>
              </div>
              <div className="wizard-success-row">
                <span className="wizard-success-label">Customer</span>
                <span className="wizard-success-value">
                  {successModal.booking.customer_name}
                </span>
              </div>
              {successModal.booking.customer_address && (
                <div className="wizard-success-row">
                  <span className="wizard-success-label">Address</span>
                  <span className="wizard-success-value">
                    {successModal.booking.customer_address}
                  </span>
                </div>
              )}
              <div className="wizard-success-row">
                <span className="wizard-success-label">Status</span>
                <span className="wizard-success-value text-success">
                  {(successModal.booking.status && STATUS_CONFIG[successModal.booking.status]?.label) || successModal.booking.status}
                </span>
              </div>
            </div>
            <div className="wizard-success-actions mt-lg">
              <button
                className="btn btn-primary"
                onClick={onClose}
              >
                Done
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="wizard-success-icon">{'\u2713'}</div>
            <h2 className="wizard-success-title mb-md">
              {successModal.message || 'Success'}
            </h2>
            <button className="btn btn-primary" onClick={onClose}>
              OK
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default BookingsSuccessModal;
